import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.map.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.set.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
export function getCommonAndIndeterminateTags(_ref) {
  var contentIds = _ref.contentIds,
    tags = _ref.tags;
  if (!contentIds || (contentIds === null || contentIds === void 0 ? void 0 : contentIds.length) === 1) {
    return {
      common: tags,
      indeterminate: []
    };
  }
  if (!tags) {
    return {
      common: [],
      indeterminate: []
    };
  }
  var tagMap = new Map();

  // Step 1: Build a map to track the occurrence of each tag in different playlists
  tags.forEach(function (tag) {
    var id = tag.id,
      name = tag.name,
      contentId = tag.contentId;

    // Initialize the tag entry if not present
    if (!tagMap.has(name)) {
      tagMap.set(name, {
        count: 0,
        playlists: new Set(),
        tagData: {
          id: id,
          name: name,
          contentId: contentId
        }
      });
    }

    // Update the tag entry
    var tagData = tagMap.get(name);
    if (!tagData) {
      return;
    }
    tagData.count += 1;
    if (contentId !== null && contentId !== undefined) {
      tagData.playlists.add(contentId);
    }
  });
  var common = [];
  var indeterminate = [];

  // Step 2: Separate common tags (appearing in every playlist or with no contentId) and indeterminate tags
  tagMap.forEach(function (data) {
    var tag = {
      id: data.tagData.id,
      name: data.tagData.name
    };
    if (data.playlists.size === contentIds.length || data.tagData.contentId === null || data.tagData.contentId === undefined) {
      common.push(tag);
    } else {
      indeterminate.push(_objectSpread(_objectSpread({}, tag), {}, {
        isIndeterminate: true
      }));
    }
  });
  return {
    common: common,
    indeterminate: indeterminate,
    all: [].concat(common, indeterminate)
  };
}
export default getCommonAndIndeterminateTags;